"use client";

import Image from "next/image";

import { documentAbi } from "@/lib/abi";
import { documentWalletAddress } from "@/lib/wagmi";
import { authSelector } from "@/store/auth/auth.slice";
import { IDocument } from "@/types/document";
import { isArray, isNumber } from "lodash";
import Link from "next/link";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAccount } from "wagmi";
import { LoginModal } from "../modals/login-modal";
import { useGlobalModal } from "../modals/modal-provider";
import { Button } from "../ui/button";
import { ConnectWallet } from "../wallet/connect-wallet";
import { If } from "./condition";
import HeaderAvatar from "./HeaderAvatar";
import MenuMoblie from "./MenuMoblie";
import { readContract } from "@wagmi/core";
import { authActions } from "@/store/actions";
import { accountSelector } from "@/store/account/account.slice";

const itemsPerPage = 10;

export default function Header() {
  const { authLogin } = useSelector(authSelector);
  const { account } = useSelector(accountSelector);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { openModal } = useGlobalModal();
  const { address } = useAccount({
    onConnect() {},
  });
  const [totalData, setTotalData] = useState(0);
  const [page, setPage] = useState(1);
  const [data, setData] = useState<IDocument[]>([]);
  // const handleLogin = () => {
  //   if (authenticated) {
  //   }
  // };

  const getDocument = async (id: number) => {
    try {
      const result = await readContract({
        abi: documentAbi,
        address: documentWalletAddress,
        functionName: "read",
        args: [id],
      });

      const file = result as IDocument;

      return { ...file, id };
    } catch (error) {
      return null;
    }
  };

  useEffect(() => {
    dispatch(
      authActions.self.setIsRightAddress(
        address?.toLocaleLowerCase() ===
          account?.walletAddress?.toLocaleLowerCase()
      )
    );
  }, [address, account]);

  const onLogin = () => {
    openModal({
      title: "Đăng nhập",
      description: "Nhập thông tin tài khoản của bạn bên dưới.",
      body: <LoginModal onSuccess={() => {}} />,
    });
  };

  return (
    <header className="bg-white shadow-sm border-b h-[88px]">
      <div className="flex flex-1 h-full justify-between items-center max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center gap-8 flex-1">
          {/* Logo */}
          <Link href="/" className="flex items-center gap-2">
            <Image width={48} height={48} src="/logo-danang.png" alt="logo" />
            <h1 className="hidden xl:block text-base xl:text-lg font-bold text-main ml-2">
              Sở Khoa học và Công nghệ TP Đà Nẵng
            </h1>
          </Link>

          <If
            condition={!authLogin}
            Then={
              <Button
                onClick={onLogin}
                className="bg-white border-2 border-main text-base font-bold text-main hover:bg-main hover:text-white hidden lg:block h-12"
              >
                Đăng nhập
              </Button>
            }
            Else={
              <div className="lg:flex items-center gap-2 hidden">
                <ConnectWallet />
                <HeaderAvatar />
              </div>
            }
          />

          <div className="lg:hidden">
            <h1 className="text-sm font-semibold text-main ml-2 text-center">
              Sở Khoa học và Công nghệ TP Đà Nẵng
            </h1>
          </div>

          <MenuMoblie />
        </div>
      </div>
    </header>
  );
}
